import { Tooltip, Typography } from '@mui/material';
import React from 'react';

type KpiWorkunitGridData = {
  mission_advancement_id: number | null;
};

const STATUS_MAP: Record<number, string> = {
  1: 'SUBMITTED',
  2: 'DM REFUSE',
  3: 'DM ACCEPTED',
  4: 'DM ACCEPTED WITH RESERVATION',
  5: 'CLIENT REFUSE',
  6: 'CLIENT ACCEPTED WITH RESERVATION',
  7: 'CLIENT ACCEPTED',
  99: 'NOT SUBMITTED',
};

const OrderStatusCell = React.memo((row: KpiWorkunitGridData) => {
  const id = row?.mission_advancement_id;
  const statusName = typeof id === 'number' ? STATUS_MAP[id] || String(id) : 'NOT SUBMITTED';

  return (
    <>
      {statusName && (
        <Tooltip title={statusName}>
          <Typography variant="body2" noWrap>
            {statusName}
          </Typography>
        </Tooltip>
      )}
    </>
  );
});

export default OrderStatusCell;
